// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-6ca33838]::-webkit-input-placeholder{opacity:.5;font-size:12px;color:#273142}input[data-v-6ca33838]::-moz-placeholder{opacity:.5;font-size:12px;color:#273142}input[data-v-6ca33838]:-ms-input-placeholder{opacity:.5;font-size:12px;color:#273142}input[data-v-6ca33838]::-ms-input-placeholder{opacity:.5;font-size:12px;color:#273142}input[data-v-6ca33838]::placeholder{opacity:.5;font-size:12px;color:#273142}.input-error[data-v-6ca33838]{margin-top:5px;margin-left:15px}", ""]);
// Exports
module.exports = exports;
